import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-neutral-950 text-stone-500 py-16 px-6 md:px-12 border-t border-neutral-900" data-id="element-27">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-28">
        <div className="text-center md:text-left" data-id="element-29">
          <h3 className="text-2xl font-serif text-stone-200 mb-2 tracking-wide" data-id="element-30">
            Cheah Family Foods
          </h3>
          <p className="text-sm font-light tracking-widest uppercase" data-id="element-31">
            Paducah, Kentucky
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-8 text-sm font-light uppercase tracking-widest" data-id="element-32">
          <a href="#restaurants" className="hover:text-amber-500 transition-colors" data-id="element-33">
            Portfolio
          </a>
          <a href="#about" className="hover:text-amber-500 transition-colors" data-id="element-34">
            Heritage
          </a>
          <a href="mailto:sun_cheah@yahoo.com" className="hover:text-amber-500 transition-colors normal-case tracking-normal" data-id="element-35">
            sun_cheah@yahoo.com
          </a>
        </div>

        <div className="text-center md:text-right text-xs font-light tracking-widest uppercase" data-id="element-36">
          <p data-id="element-37">&copy; {currentYear} Cheah Family Foods.</p>
          <p className="mt-2" data-id="element-38">All rights reserved.</p>
        </div>
      </div>
    </footer>;
}